export enum AppEventsEnum {
  APP_READY_LOGGED_IN = 'APP_READY_LOGGED_IN',
  UPDATE_CLONE_RECEIVED = 'UPDATE_CLONE_RECEIVED',
  NEW_INNER_TAB_RECEIVED = 'NEW_INNER_TAB_RECEIVED',
  INNER_VIEW_LOADED = 'INNER_VIEW_LOADED',
  CHECK_FOR_UPDATES = 'CHECK_FOR_UPDATES',
  CLOSE_APP = 'CLOSE_APP',
  TOGGLE_FULL_SCREEN = 'TOGGLE_FULL_SCREEN',
  MINIMIZE = 'MINIMIZE',
  SEND_LOGS = 'SEND_LOGS',
  SHOW_LOGS = 'SHOW_LOGS',
  SHOW_SCREEN_RECORDINGS = 'SHOW_SCREEN_RECORDINGS',
  CLEAR_CACHE_AND_RELAUNCH = 'CLEAR CACHE_AND_RELAUNCH',
  LOGS_SENT = 'LOGS_SENT',
  ABOUT_US = 'ABOUT_US',
  DIAGNOSTIC_CHECK = 'DIAGNOSTIC_CHECK',
  UPDATE_AVAILABLE = 'UPDATE_AVAILABLE',
  UPDATE_NOT_AVAILABLE = 'UPDATE_NOT_AVAILABLE',
  UPDATE_DOWNLOADED = 'UPDATE_DOWNLOADED',
  INSTALL_UPDATES = 'INSTALL_UPDATES',
  RELAUNCH_APP = 'RELAUNCH_APP',
  UPDATE_APP = 'UPDATE_APP',
  OPEN_HELP_CENTER = 'OPEN_HELP_CENTER',
  OPEN_RELEASE_NOTES = 'OPEN_RELEASE_NOTES',
  UPDATE_MENU_STATES_ON_LOGIN_SCREEN = 'UPDATE_MENU_STATES_ON_LOGIN_SCREEN',
  APP_VIEW_TO_MAIN_SET_INNER_VIEW_ZOOM = 'APP_VIEW_TO_MAIN_SET_INNER_VIEW_ZOOM',
  MAIN_TO_APP_VIEW_INNER_VIEW_ZOOM_CHANGE = 'MAIN_TO_APP_VIEW_INNER_VIEW_ZOOM_CHANGE',
  APP_VIEW_TO_MAIN_SEND_LOGS = 'APP_VIEW_TO_MAIN_SEND_LOGS',
  ON_NOTIFICATION_MESSAGE = 'ON_NOTIFICATION_MESSAGE',
  PRELOAD_TO_MAIN_GET_APP_VERSION = 'PRELOAD_TO_MAIN_GET_APP_VERSION',
  MAIN_TO_APP_NAVIGATE_TO = 'MAIN_TO_APP_NAVIGATE_TO',
  APP_VIEW_TO_MAIN_GET_MIMESIS_ENGINE_URL = 'APP_VIEW_TO_MAIN_GET_MIMESIS_ENGINE_URL',
  MAIN_TO_APP_CREATE_TOUR = 'MAIN_TO_APP_CREATE_TOUR',
  MAIN_TO_APP_CLONER_OPEN = 'MAIN_TO_APP_CLONER_OPEN',
  MAIN_TO_APP_EDITOR_OPEN = 'MAIN_TO_APP_EDITOR_OPEN',
  MAIN_TO_APP_PRESENTER_DEEPLINK = 'MAIN_TO_APP_PRESENTER_DEEPLINK',
  SHOW_RESTART_APP_MODAL = 'SHOW_RESTART_APP_MODAL',
  RENDERER_TO_MAIN_SHOW_ZOOM_POPUP = 'RENDERER_TO_MAIN_SHOW_ZOOM_POPUP',
  MAIN_TO_RENDERER_SHOW_ZOOM_POPUP = 'MAIN_TO_RENDERER_SHOW_ZOOM_POPUP',
  MAIN_TO_APP_LOGIN_SUCCESS = 'MAIN_TO_APP_LOGIN_SUCCESS',
  APP_VIEW_TO_MAIN_REFETCH_USER_ME = 'APP_VIEW_TO_MAIN_REFETCH_USER_ME',
  MAIN_TO_APP_VIEW_SET_TAB_TITLE = 'MAIN_TO_APP_VIEW_SET_TAB_TITLE',
  MAIN_TO_APP_VIEW_SET_TAB_URL = 'MAIN_TO_APP_VIEW_SET_TAB_URL',
  MAIN_TO_APP_VIEW_SET_TAB_FAVICON = 'MAIN_TO_APP_VIEW_SET_TAB_FAVICON',
  MAIN_TO_APP_VIEW_BROWSER_MODE_INVALID_URL = 'MAIN_TO_APP_VIEW_BROWSER_MODE_INVALID_URL',
  MAIN_TO_RENDERER_MONITORING_DATA = 'MAIN_TO_RENDERER_MONITORING_DATA',
  MAIN_TO_APP_CHANGE_ORGANIZATION = 'MAIN_TO_APP_CHANGE_ORGANIZATION',
  RENDERER_TO_MAIN_GET_PDF_JS = 'RENDERER_TO_MAIN_GET_PDF_JS',
  APP_VIEW_TO_MAIN_OPEN_EXTERNAL_BROWSER = 'APP_VIEW_TO_MAIN_OPEN_EXTERNAL_BROWSER',
  RENDERER_TO_MAIN_OPEN_DEEPLINK = 'RENDERER_TO_MAIN_OPEN_DEEPLINK',
  MAIN_TO_RENDERER_OPEN_GO_TO_MODAL = 'MAIN_TO_RENDERER_OPEN_GO_TO_MODAL',
  RENDERER_TO_MAIN_OPEN_GO_TO_MODAL = 'RENDERER_TO_MAIN_OPEN_GO_TO_MODAL',
  RENDERER_TO_MAIN_GET_SYSTEM_INFO = 'RENDERER_TO_MAIN_GET_SYSTEM_INFO',
  RENDERER_TO_MAIN_GET_ELECTRON_ONLINE_STATUS = 'RENDERER_TO_MAIN_GET_ELECTRON_ONLINE_STATUS',
  RENDERER_TO_MAIN_ELEMENT_LOADED = 'RENDERER_TO_MAIN_ELEMENT_LOADED',
  MAIN_TO_RENDERER_INNER_VIEW_READY_FOR_ZOOM = 'MAIN_TO_RENDERER_INNER_VIEW_READY_FOR_ZOOM',
  RENDERER_TO_MAIN_GET_MAIN_WINDOW_SOURCE = 'RENDERER_TO_MAIN_GET_MAIN_WINDOW_SOURCE',
  RENDERER_TO_MAIN_SAVE_SCREEN_RECORDING = 'RENDERER_TO_MAIN_SAVE_SCREEN_RECORDING',
  RENDERER_TO_MAIN_CALC_CACHE_DIRECTORY_SIZE = 'RENDERER_TO_MAIN_CALC_CACHE_DIRECTORY_SIZE',
  RENDERER_TO_MAIN_CLEAR_CACHE_DIRECTORY = 'RENDERER_TO_MAIN_CLEAR_CACHE_DIRECTORY',
  RENDERER_TO_MAIN_CALC_TOTAL_FREE_DISK_SPACE = 'RENDERER_TO_MAIN_CALC_TOTAL_FREE_DISK_SPACE',
  MAIN_TO_RENDERER_ON_APP_FOCUS_CHANGE = 'MAIN_TO_RENDERER_ON_APP_FOCUS_CHANGE',
  RENDERER_TO_MAIN_GET_HTML_PATH = 'RENDERER_TO_MAIN_GET_HTML_PATH',
  APP_TO_RELATED_VIEW = 'APP_TO_RELATED_VIEW',
  MAIN_TO_RENDERER_GLOBAL_TABS_KEYBOARD_SWITCH = 'MAIN_TO_RENDERER_GLOBAL_TABS_KEYBOARD_SWITCH',
  RENDERER_TO_MAIN_CAPTURE_PAGE = 'RENDERER_TO_MAIN_CAPTURE_PAGE',
  RENDERER_TO_MAIN_GET_INNER_PAGE_HTML = 'RENDERER_TO_MAIN_GET_INNER_PAGE_HTML',
  RENDERER_TO_MAIN_IS_UPDATES_DISABLED = 'RENDERER_TO_MAIN_IS_UPDATES_DISABLED',
  RENDERER_TO_MAIN_SET_LOGROCKET_LINK = 'RENDERER_TO_MAIN_SET_LOGROCKET_LINK',
}
